/* BHC Motion — expanded scroll/entrance engine. Updated 2026-08-27. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- word splitter (preserves inline tags like <em>) ---------- */
  function splitWords(el) {
    if (!el || el.dataset.bhcSplit) return [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);

    var words = [];
    nodes.forEach(function (node) {
      if (!node.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
        } else {
          var span = document.createElement('span');
          span.className = 'bhc-word';
          span.textContent = part;
          frag.appendChild(span);
          words.push(span);
        }
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.dataset.bhcSplit = '1';
    return words;
  }

  /* ---------- 1. scroll progress bar ---------- */
  var bar = document.createElement('div');
  bar.id = 'bhc-progress';
  document.body.appendChild(bar);

  /* ---------- 2. hero staging ---------- */
  var hero = $('.bhc-hero');
  var heroHeading = $('.bhc-hero__heading');

  if (heroHeading) {
    var hw = splitWords(heroHeading);
    if (hw.length) {
      heroHeading.classList.add('bhc-split');
      hw.forEach(function (w, i) {
        w.style.animationDelay = (0.45 + i * 0.075).toFixed(3) + 's';
      });
    }
  }

  if (hero && !$('.bhc-scroll-cue', hero)) {
    var cue = document.createElement('div');
    cue.className = 'bhc-scroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    hero.appendChild(cue);
  }

  /* ---------- 3. section headings ---------- */
  $$('.bhc-new-arrivals__heading, .bhc-col-cards__heading, .bhc-heritage__heading, .bhc-brand-story__heading, .bhc-newsletter__heading')
    .forEach(function (h) {
      var align = window.getComputedStyle(h).textAlign;
      var ws = splitWords(h);
      if (!ws.length) return;
      h.classList.add('bhc-head-anim');
      if (align !== 'center') h.classList.add('bhc-head-anim--start');
      ws.forEach(function (w, i) {
        w.style.transitionDelay = (i * 0.06).toFixed(3) + 's';
      });
    });

  /* ---------- 4. reveal targets ---------- */
  function mark(sel, cls) {
    $$(sel).forEach(function (el) {
      cls.split(' ').forEach(function (c) { el.classList.add(c); });
    });
  }

  mark('.bhc-heritage__content', 'bhc-reveal bhc-reveal--left');
  mark('.bhc-heritage__image', 'bhc-reveal bhc-reveal--right bhc-wipe');
  mark('.bhc-brand-story__content', 'bhc-reveal bhc-reveal--right');
  mark('.bhc-brand-story__logos', 'bhc-reveal bhc-reveal--left');
  mark('.bhc-col-cards__grid', 'bhc-stagger');
  mark('.bhc-cg__grid', 'bhc-stagger');
  mark('.bhc-pt__badges', 'bhc-stagger');
  mark('.bhc-newsletter__inner, .bhc-product-trust', 'bhc-reveal');

  /* ---------- 5. observer + fast-scroll safety net ---------- */
  var pending = $$('.bhc-reveal, .bhc-stagger, .bhc-head-anim, .bhc-wipe');

  function reveal(el) {
    el.classList.add('bhc-in-view');
  }

  if ('IntersectionObserver' in window && pending.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            reveal(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    pending.forEach(function (el) { io.observe(el); });
  } else {
    pending.forEach(reveal);
    pending = [];
  }

  /* Never leave an element hidden because a fast scroll skipped it. */
  function sweep() {
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      if (el.classList.contains('bhc-in-view')) {
        pending.splice(i, 1);
        continue;
      }
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        reveal(el);
        pending.splice(i, 1);
      }
    }
  }

  /* ---------- 6. scroll-driven: progress, parallax, header ---------- */
  var headerGroup = $('#header-group');
  var slowTargets = $$('.bhc-heritage__image');
  var ticking = false;

  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var max = document.documentElement.scrollHeight - window.innerHeight;

    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';

    if (hero) {
      var h = hero.offsetHeight || 1;
      if (y < h * 1.2) {
        hero.style.setProperty('--bhc-parallax', (y * 0.28).toFixed(1) + 'px');
      }
    }

    slowTargets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var mid = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.setProperty('--bhc-parallax-slow', (mid * -0.06).toFixed(1) + 'px');
      }
    });

    if (headerGroup) {
      headerGroup.classList.toggle('bhc-header--scrolled', y > 40);
    }

    sweep();
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScroll);
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', sweep, { passive: true });
  window.addEventListener('load', sweep);

  onScroll();
})();
